// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#right-side-panel {
  width: 20%;
  background: #fff;
  box-shadow: 0px 0px 4px #b2b2b2;
  padding: 10px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/ai-assist/bottemplate/bottemplate.component.scss"],"names":[],"mappings":"AAAA;EACI,UAAA;EACA,gBAAA;EACA,+BAAA;EACA,aAAA;AACJ","sourcesContent":["#right-side-panel{\n    width:20%;\n    background:#fff;\n    box-shadow:0px 0px 4px #b2b2b2;\n    padding:10px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
